import { render, staticRenderFns } from "./Howzit.vue?vue&type=template&id=66322e90&"
import script from "./Howzit.vue?vue&type=script&lang=js&"
export * from "./Howzit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports